import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"

import {
  ORDERED_TEAM_ROLES,
  TeamRole
} from "entities/team-members/types/TeamRole"

export function useTeamRoleOptions() {
  const { t } = useTranslation()
  return useMemo<SelectOption<TeamRole>[]>(
    () =>
      ORDERED_TEAM_ROLES.map(role => ({
        value: role,
        label: t(`Team.Role.${role}`)
      })),
    [t]
  )
}
